// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GuideBox_wrapper__1yF5L","actions":"GuideBox_actions__u0awt","hidden":"GuideBox_hidden__pxwGz","content":"GuideBox_content__10pSt","bottom":"GuideBox_bottom__vwBgj"};